import { ILabel } from './model';

export class Label implements ILabel {
	CategoryID: string;
	ID: string;
	Name: string;
	public static fromInterface(data: ILabel) {
		const rev = new Label();
		Object.assign(rev, data);
		return rev;
	}
	displayLabel(): string {
		return this.Name;
	}
	equal(data: Label): boolean {
		return this.CategoryID === data.CategoryID && this.ID === data.ID && this.Name === data.Name;
	}
}
